import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query. Falls back to `false` (desktop-first) when
 * matchMedia is unavailable (e.g. jsdom), so tests render the desktop layout.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Tailwind `md` breakpoint — below this the layout collapses to stacked. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
